import React, {forwardRef, useEffect, useImperativeHandle} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import withIntl from '../../../lib/withIntl';
import '../SetupWizard.scss';
import SetupWizardGeneralStepPage from './SetupWizardGeneralStepPage';
import {
  handleEjectTray,
  handleSWizardAutoCalibration,
  handleTouchProbeRetract,
} from '../../../stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';
import {checkOngoingCalibration} from '../../../stores/business/trayCalibrationBusiness';

const mapStateToProps = (state) => ({
  wizardFlagState: state.wizardState.wizardFlag,
});

const mapDispatchToProps = (dispatch) => ({
  trayCalibrationBusinessCheckOngoingCalibration: bindActionCreators(checkOngoingCalibration, dispatch),
  SWInstrumentBusinessAutoCalibration: bindActionCreators(handleSWizardAutoCalibration, dispatch),
  SWInstrumentBusinessHandleEjectTray: bindActionCreators(handleEjectTray, dispatch),
  SWInstrumentBusinessHandleTouchProbeRetract: bindActionCreators(handleTouchProbeRetract, dispatch),
});

const StepThreeSetupWizard = forwardRef(
  (
    {
      trayCalibrationBusinessCheckOngoingCalibration,
      SWInstrumentBusinessAutoCalibration,
      SWInstrumentBusinessHandleEjectTray,
      SWInstrumentBusinessHandleTouchProbeRetract,
    },
    ref,
  ) => {
    const onButtonClick = () => SWInstrumentBusinessAutoCalibration();
    const onContinue = async () => {
      await SWInstrumentBusinessHandleTouchProbeRetract();
      await SWInstrumentBusinessHandleEjectTray();
    };
    const onBack = async () => {
      await SWInstrumentBusinessHandleTouchProbeRetract();
    };

    useImperativeHandle(ref, () => ({
      onContinue,
      onBack,
    }));

    useEffect(() => {
      trayCalibrationBusinessCheckOngoingCalibration();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <SetupWizardGeneralStepPage withTitleAndBodyText={false} onButtonClick={onButtonClick} />;
  },
);

StepThreeSetupWizard.propTypes = {
  trayCalibrationBusinessCheckOngoingCalibration: PropTypes.func.isRequired,
  SWInstrumentBusinessAutoCalibration: PropTypes.func.isRequired,
  SWInstrumentBusinessHandleEjectTray: PropTypes.func.isRequired,
  SWInstrumentBusinessHandleTouchProbeRetract: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(withIntl(StepThreeSetupWizard));
